export const rankingCompanies = [
  {
    rank: 1,
    name: "リボンエナジー",
    tagline: "オール電化割引を含む7つの割引を併用可能！基本料金0円で、オール電化の家庭にフィット",
    basicFee: "0円",
    unitPrice: "市場連動型",
    recommended: "電気をよく使うファミリー層・オール電化・戸建て・ペットと暮らしている方",
    area: "全国（沖縄県と一部離島を除く）",
    campaign: "WEBからのお申込みで「6か月間」電気代割引！",
    initialCost: "0円",
    contractBinding: "なし",
    fuelAdjust: "0円",
    switchingSupport: "すべてリボンエナジーにお任せOK（手続き不要）",
    switchingDays: "7日程度",
    movingDeadline: "2日前までに申し込み",
    cancelFee: "0円",
    color: "#F59E0B",
    badge: "人気No.1",
    points: [
      "基本料金0円",
      "燃料費調整額0円",
      "7つの割引すべて併用可",
      "解約金・初期費用0円",
      "切り替え手続き代行",
    ],
    image: `${__BASE_PATH__}public/img/logo_ribon.png`,
    cardImage: `${__BASE_PATH__}public/img/logo_ribon_small.png`,
    comment: "基本料金0円。オール電化に特化した割引メニューと、他にも合計7つの割引を併用できるから、消費電力が多い家庭ほどお得になる電力会社！",
    discounts: "オール電化割引 / マイホーム割引 / ペット割引 / ファミリー割引 / 太陽光割引 / 蓄電池割引 / EV割引（すべて併用可）",
  },
  {
    rank: 2,
    name: "オクトパスエナジー",
    tagline: "住まいや生活スタイルに合わせてプランを選べるからピッタリなものが見つけやすい",
    basicFee: "グリーンオクトパス: 10Aあたり291円/月\nシンプルオクトパス: 0円\nオール電化オクトパス: 10Aあたり307.50円/月",
    unitPrice: "プランにより異なる",
    recommended: "再生可能エネルギーに関心がある人・一人暮らしの人",
    area: "全国（沖縄県と一部離島を除く）",
    campaign: "なし（友達紹介割あり）",
    initialCost: "0円（設置状況によっては工事費が発生する場合あり）",
    contractBinding: "なし",
    fuelAdjust: "あり",
    switchingSupport: "手続き不要",
    switchingDays: "2〜3週間",
    movingDeadline: "6営業日前までに申し込み",
    cancelFee: "0円",
    color: "#10B981",
    badge: "環境◎",
    points: [
      "100%再生可能エネルギー対応",
      "解約手数料0円",
      "契約期間の縛りなし",
      "新プランの提案・節電施策あり",
    ],
    image: `${__BASE_PATH__}public/img/logo_oct.png`,
    cardImage: `${__BASE_PATH__}public/img/logo_oct_small.png`,
    comment: "「安い」だけじゃない！新プランの提案や楽しく取り組める節電施策＆お役立ち情報も提供",
    discounts: "なし",
  },
  {
    rank: 3,
    name: "Looopでんき",
    tagline: "解約手数料0円！契約期間の縛りもなしだから気軽に切り替えができる電力会社として人気",
    basicFee: "あり",
    unitPrice: "市場価格連動",
    recommended: "ガスとのセット利用を検討している人・電気料金の安い時間帯に活用できる人",
    area: "全国（一部離島を除く）",
    campaign: "なし",
    initialCost: "0円",
    contractBinding: "なし",
    fuelAdjust: "0円",
    switchingSupport: "手続き不要",
    switchingDays: "2〜3週間",
    movingDeadline: "2〜3日前までに申し込み",
    cancelFee: "0円",
    color: "#22C55E",
    badge: "解約金0円",
    points: [
      "燃料費調整額0円",
      "解約手数料0円",
      "契約期間の縛りなし",
      "初期費用0円",
    ],
    image: `${__BASE_PATH__}public/img/logo_looop.png`,
    cardImage: `${__BASE_PATH__}public/img/logo_looop_small.png`,
    comment: "解約手数料0円！契約期間の縛りもなしだから気軽に切り替えができる電力会社として人気",
    discounts: "なし",
  },
  {
    rank: 4,
    name: "しろくま電力（ぱわー）",
    tagline: "蓄電池を使って電気代を構造的に安くする電力会社。料金を安く抑えたい方におすすめ",
    basicFee: "0円",
    unitPrice: "市場連動型",
    recommended: "気軽にグリーン電力を利用したい人・環境問題に関心のある人",
    area: "全国（沖縄県と一部離島を除く）",
    campaign: "公式サイトから「しろくまプラン」申し込みで最大15,000円分のPayPayポイントをプレゼント（世田谷区民限定）",
    initialCost: "0円",
    contractBinding: "なし",
    fuelAdjust: "電源調達調整費あり（燃料費調整額ではない）",
    switchingSupport: "手続き不要",
    switchingDays: "2〜3週間",
    movingDeadline: "3営業日前までに申し込み",
    cancelFee: "0円",
    color: "#60A5FA",
    badge: "グリーン◎",
    points: [
      "基本料金0円",
      "グリーン電力対応",
      "解約金・初期費用0円",
      "PayPayポイントキャンペーンあり",
    ],
    image: `${__BASE_PATH__}public/img/logo_shirokuma.png`,
    cardImage: `${__BASE_PATH__}public/img/logo_shirokuma_small.png`,
    comment: "蓄電池を使って電気代を構造的に安くする電力会社◎料金を安く抑えたい方におすすめ",
    discounts: "なし",
  },
  {
    rank: 5,
    name: "auでんき",
    tagline: "auが提供するサービスだから、安心して切り替えられる",
    basicFee: "50A: 1,459.72円/月\n60A: 1,751.67円/月",
    unitPrice: "19.27円/kWh〜（最初の120kWhまで）",
    recommended: "Pontaポイントを貯めている人・au経済圏のサービスをよく利用する人",
    area: "全国（一部離島を除く）",
    campaign: "2ヶ月目の電気代から最大5,000円割引（au・UQモバイルユーザー限定）",
    initialCost: "0円",
    contractBinding: "なし",
    fuelAdjust: "あり",
    switchingSupport: "手続き不要",
    switchingDays: "2〜3週間",
    movingDeadline: "11日前までに申し込み",
    cancelFee: "0円",
    color: "#F97316",
    badge: "ポイント◎",
    points: [
      "Pontaポイントが貯まる",
      "解約金・初期費用0円",
      "au・UQモバイルユーザーに最大5,000円割引",
      "契約期間の縛りなし",
    ],
    image: `${__BASE_PATH__}public/img/logo_audenki.png`,
    cardImage: `${__BASE_PATH__}public/img/logo_audenki_small.png`,
    comment: "auが提供するサービス！契約や手続きに一切費用はかからないから安心して切り替えられる",
    discounts: "なし",
  },
];

export const comparisonItems = [
  {
    label: "基本料金",
    a: "0円",
    b: "プランにより異なる",
    c: "あり",
    d: "0円",
    e: "プランにより異なる",
    aRating: "◎",
    bRating: "△",
    cRating: "△",
    dRating: "◎",
    eRating: "△",
  },
  {
    label: "燃料費調整額",
    a: "0円",
    b: "あり",
    c: "0円",
    d: "電源調達調整費あり",
    e: "あり",
    aRating: "◎",
    bRating: "△",
    cRating: "◎",
    dRating: "△",
    eRating: "△",
  },
  {
    label: "割引制度",
    a: "7種類すべて併用可",
    b: "なし",
    c: "なし",
    d: "なし",
    e: "なし",
    aRating: "◎",
    bRating: "△",
    cRating: "△",
    dRating: "△",
    eRating: "△",
  },
  {
    label: "初期費用",
    a: "0円",
    b: "設置状況によっては、別途工事費が発生する場合あり",
    c: "0円",
    d: "0円",
    e: "0円",
    aRating: "◎",
    bRating: "◯",
    cRating: "◎",
    dRating: "◎",
    eRating: "◎",
  },
  {
    label: "解約金",
    a: "0円",
    b: "0円",
    c: "0円",
    d: "0円",
    e: "0円",
    aRating: "◎",
    bRating: "◎",
    cRating: "◎",
    dRating: "◎",
    eRating: "◎",
  },
  {
    label: "契約縛り",
    a: "なし",
    b: "なし",
    c: "なし",
    d: "なし",
    e: "なし",
    aRating: "◎",
    bRating: "◎",
    cRating: "◎",
    dRating: "◎",
    eRating: "◎",
  },
  {
    label: "切り替え手続き",
    a: "代行あり・手続き不要",
    b: "手続き不要",
    c: "手続き不要",
    d: "手続き不要",
    e: "手続き不要",
    aRating: "◎",
    bRating: "◎",
    cRating: "◎",
    dRating: "◎",
    eRating: "◎",
  },
  {
    label: "切り替え期間",
    a: "7日程度",
    b: "2〜3週間",
    c: "2〜3週間",
    d: "2〜3週間",
    e: "2〜3週間",
    aRating: "◎",
    bRating: "△",
    cRating: "△",
    dRating: "△",
    eRating: "△",
  },
  {
    label: "引越し申込期限",
    a: "2日前まで",
    b: "6営業日前まで",
    c: "2〜3日前まで",
    d: "3営業日前まで",
    e: "11日前まで",
    aRating: "◎",
    bRating: "△",
    cRating: "◯",
    dRating: "◯",
    eRating: "◯",
  },
  {
    label: "供給エリア",
    a: "全国",
    b: "全国",
    c: "全国",
    d: "全国",
    e: "全国",
    aRating: "◎",
    bRating: "◎",
    cRating: "◎",
    dRating: "◎",
    eRating: "◎",
  },
];

export const faqItems = [
  {
    q: "切り替えの手続きには何が必要ですか？",
    a: "現在契約中の電力会社名・供給地点特定番号（22桁）・お客さま番号（契約番号）が必要です。現在契約中の電力会社のマイページや検針票をご用意ください。",
  },
  {
    q: "初期費用・解約金・契約期間の縛りはありますか？",
    a: "いずれもありません。初期費用・解約金は不要で、契約期間の縛りもないため、気軽にお申し込みいただけます。",
  },
  {
    q: "停電が起こりやすくなることはありますか？",
    a: "いいえ。電気を供給するための仕組みは今までと変わらないため、停電リスクは同じです。これまでと同じ品質で電気をご利用いただけます。",
  },
  {
    q: "オール電化住宅でも契約できますか？切り替えに工事は必要ですか？",
    a: "基本的に工事不要ですが、一部メーター交換が必要な場合があります（無料）。オール電化住宅でも問題なくご契約いただけます。",
  },
];